import { render } from "./LabelList.vue?vue&type=template&id=455123da&scoped=true"
import script from "./LabelList.vue?vue&type=script&lang=js"
export * from "./LabelList.vue?vue&type=script&lang=js"

import "./LabelList.vue?vue&type=style&index=0&id=455123da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455123da"]])

export default __exports__